<template>
  <Popover class="absolute inset-0">
    <PopoverButton class="absolute inset-0 flex justify-center items-center" @click="show">
      <EllipsisHorizontalIcon class="h-4 w-4 mr-1" />
    </PopoverButton>

    <transition-appear origin="center">
      <PopoverPanel v-if="isOpened" class="absolute top-[5px] right-[5px] w-screen max-w-max" static>
        <OnClickOutside @trigger="close">
          <div class="isolate inline-flex rounded-md shadow-lg">
            <button
              type="button"
              class="btn-list-action rounded-l-md"
              @click="emit('delete', row)"
            >
              <TrashIcon class="mr-2 h-3 text-slate-400" />
              Delete
            </button>

            <button
              v-if="row.isEnabled"
              type="button"
              class="btn-list-action"
              @click="emit('disable', row)"
            >
              <LockClosedIcon class="mr-2 h-3 text-slate-400" />
              Disable
            </button>

            <button
              v-else
              type="button"
              class="btn-list-action"
              @click="emit('enable', row)"
            >
              <LockOpenIcon class="mr-2 h-3 text-slate-400" />
              Enable
            </button>

            <router-link
              :to="`/plugin/${row.id}`"
              class="btn-list-action rounded-r-md"
            >
              <PencilSquareIcon class="mr-2 h-3 text-slate-400" />
              Edit
            </router-link>
          </div>
        </OnClickOutside>
      </PopoverPanel>
    </transition-appear>
  </Popover>
</template>

<script setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';
import TransitionAppear from './TransitionAppear.vue';
import { ref, watch } from 'vue';
import { OnClickOutside } from '@vueuse/components';
import { EllipsisHorizontalIcon, TrashIcon, PencilSquareIcon, LockOpenIcon, LockClosedIcon } from '@heroicons/vue/24/outline';

const props = defineProps({
  row: {
    type: Object,
    default: () => {}
  },
  index: {
    type: Number,
    default: null
  },
  isRowHovered: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'delete', 'enable', 'disable' ]);

const isOpened = ref(false);

watch(() => props.isRowHovered, val => isOpened.value = val);

function show() {
  isOpened.value = true;
}

function close() {
  isOpened.value = false;
}
</script>
